import jwtDecode from "jwt-decode";
import { setAuthHeader } from "../../services/index.service";
import { setLoggedInUser, logOutUser } from "../../actions/auth.action";

class TokenHelpers {
  static getUserDetails() {
    const tokenExists = TokenHelpers.checkIfTokenExist();
    const token = TokenHelpers.getToken();
    const isValid = TokenHelpers.isTokenValid(token);
    if (!isValid) {
      return "EXPIRED";
    }
    if (tokenExists) {
      const decoded = TokenHelpers.decodeToken(token);
      return decoded;
    }
  }
  static getUserStatus() {
    const tokenExists = TokenHelpers.checkIfTokenExist();
    const token = TokenHelpers.getToken();
    const isValid = TokenHelpers.isTokenValid(token);
    if (!isValid) {
      return "EXPIRED";
    }
    if (tokenExists) {
      const decoded = TokenHelpers.decodeToken(token);
      return decoded["account_status"];
    }
  }

  static checkIfTokenExist() {
    const token = TokenHelpers.getToken();
    return !!token;
  }

  static getToken() {
    const token = localStorage.getItem("token");
    return token;
  }

  static getFromStorage(key) {
    return localStorage.getItem(key);
  }

  static save(key, value) {
    localStorage.setItem(key, value);
  }

  static deleteToken() {
    localStorage.removeItem("token");
  }

  static decodeToken(token) {
    return jwtDecode(token);
  }

  static isTokenValid(token) {
    try {
      const decoded = TokenHelpers.decodeToken(token);
      const currentTime = Date.now();
      const tokenExpiry = decoded.exp * 1000;
      const checkIfExpired = tokenExpiry - currentTime > 1;
      return checkIfExpired;
    } catch (error) {
      return false;
    }
  }

  static autoLogIn(store) {
    const token = TokenHelpers.getToken();
    if (token && TokenHelpers.isTokenValid(token)) {
      setAuthHeader(token);
      store.dispatch(setLoggedInUser(token));
    } else if (token) {
      store.dispatch(logOutUser());
    }
  }
}

export default TokenHelpers;
